import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getAllBureauxRequest: ['response'],
    getAllBureauxSuccess: ['response', 'loading'],
    getAllBureauxFailure: ['error'],
})

export const getAllBureauxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getAllBureauxSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getAllBureauxFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getAllBureauxRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_ALL_BUREAUX_REQUEST]: getAllBureauxRequest,
    [Types.GET_ALL_BUREAUX_SUCCESS]: getAllBureauxSuccess,
    [Types.GET_ALL_BUREAUX_FAILURE]: getAllBureauxFailure,
})
